<template>
    <gcmcn-layout
        title="ADMIN NOTIFICATION"
        custom-class="admin-notification"
    >
        <el-button
            slot="action-btn"
            type="primary"
            class="gcmcn-primary-btn"
            @click="onCreateConfig"
        >
            Create notification configuration
        </el-button>
        <el-row class="main-content">
            <el-col
                :span="24"
                :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
                style="overflow: auto; padding-bottom: 40px"
            >
                <ns-paginate-2
                    ref="nsPaginate"
                    baseUrl="admin-notif-config/"
                    tableTitle="Admin notifications"
                    :hide-filters-by-default="true"
                    :display-csv-button="false"
                    dark
                >

                    <div
                        slot="list"
                        slot-scope="props"
                    >
                        <el-table
                            :data="props.list"
                            style="width: 100%"
                            class="ns-paginate-table dark-theme"
                        >
                            <el-table-column
                                prop="contact"
                                label="Contact"
                            >
                                <template slot-scope="scope">
                                    <span v-if="!isBeingEdited(scope.row.uid)">
                                        {{scope.row.contact}}
                                    </span>
                                    <el-input
                                        class="gcmcn-input"
                                        v-else
                                        v-model="scope.row.contact"
                                        :class="{ 'is-error' : contactIsInvalid(scope.row.uid)}"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="subjects_uid"
                                label="Subjects"
                            >
                                <template slot-scope="scope">
                                    <span v-if="!isBeingEdited(scope.row.uid)">
                                        <span v-if='scope.row.all_subjects'>
                                            <el-tag size="small" class="subject-tag">
                                                All

                                            </el-tag>
                                        </span>
                                        <span v-else>
                                            <el-tag
                                                v-for="subject in scope.row.subjects"
                                                :key="subject.uid"
                                                class="subject-tag"
                                                size="small"
                                            >
                                                {{ subject.name }}
                                            </el-tag>
                                        </span>
                                    </span>
                                    <span v-else class="gcmcn-form-input">
                                        <el-switch
                                            v-model="scope.row.all_subjects"
                                            active-text="All"
                                            inactive-text="Some"
                                            :active-value="true"
                                            :inactive-value="false"
                                            style="margin-bottom: 5px;"
                                        ></el-switch>
                                        <el-select
                                            v-if="!scope.row.all_subjects"
                                            v-model="scope.row.subjects_uid"
                                            placeholder="Select"
                                            popper-class="gcmcn-popper"
                                            multiple
                                            collapse-tags
                                            style="display: block;"
                                            :class="{ 'is-error' : subjectsAreInvalid(scope.row.uid)}"
                                        >
                                            <el-option
                                                v-for="item in $store.getters.adminNotifSubjects"
                                                :key="item.uid"
                                                :label="item.name"
                                                :value="item.uid">
                                            </el-option>
                                        </el-select>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Availability"
                                width="130"
                            >
                                <template slot-scope="scope">
                                    <availability-checklist
                                        :active_day="scope.row.active_day"
                                        :active_night="scope.row.active_night"
                                        :active_weekend="scope.row.active_weekend"
                                        :disabled="!isBeingEdited(scope.row.uid)"
                                        @updateAvailability="updateAvailability"
                                    ></availability-checklist>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="active"
                                label="Active"
                                width="130"
                            >
                                <template slot-scope="scope">
                                    <el-switch
                                        v-model="scope.row.active"
                                        :disabled="!isBeingEdited(scope.row.uid)"
                                        active-text="Yes"
                                        :active-value="true"
                                        inactive-text="No"
                                        :inactive-value="false"
                                    ></el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Action"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        v-if="editLineUid !== scope.row.uid"
                                        :disabled="editLineUid !== ''"
                                        type="primary"
                                        icon="el-icon-edit"
                                        @click="editLine(scope.row)"
                                    >
                                        Edit
                                    </el-button>
                                    <div v-else>
                                        <el-button
                                            class="gcmcn-primary-btn"
                                            icon="el-icon-check"
                                            @click="saveLine(scope.row)"
                                        >
                                            Save
                                        </el-button>
                                        <div>
                                            <small>{{errorText(scope.row.uid)}}</small>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </ns-paginate-2>
            </el-col>
        </el-row>
        <modal-create-admin-notif ref="modal" @admin-notif-created="onAdminNotifCreated"></modal-create-admin-notif>
    </gcmcn-layout>
</template>

<script>
import { NsPaginate2 } from 'fundation-app-vuejs';
import 'fundation-app-vuejs/src/components/partials/nsPaginate2/-new-ns-paginate-list.vue';
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import AvailabilityChecklist from './availability-checklist.vue';
import ModalCreateAdminNotif from './modal-create-admin-notif.vue';
export default {

    components: {
        NsPaginate2,
        GcmcnLayout,
        AvailabilityChecklist,
        ModalCreateAdminNotif,
    },

    props: {

    },

    data (){
        return {
            editLineUid: '',
            validContact: true,
            validSubjects: true,
            availabilityChecklist: [],
        };
    },

    computed: {
        listFieldToDisplay() {
            return [
                {
                    key: 'contact',
                    verbose: 'Contact',
                },
                {
                    key: 'active',
                    verbose: 'Active',
                },
            ];
        },
    },

    mounted (){

    },

    methods: {
        isBeingEdited(uid) {
            return this.editLineUid === uid;
        },

        contactIsInvalid(uid) {
            return this.isBeingEdited(uid) && !this.validContact;
        },

        subjectsAreInvalid(uid) {
            return this.isBeingEdited(uid) && !this.validSubjects;
        },
        editLine(row){
            this.editLineUid = row.uid;
        },
        updateAvailability(val) {
            this.availabilityChecklist = val;
        },
        saveLine(row){
            let subjectsValid = this.checkSubjects(row.all_subjects, row.subjects_uid);
            let contactValid = this.checkContactValid(row.contact);
            if(subjectsValid && contactValid) {

                this.validSubjects = true;
                this.validContact = true;

                let item = {
                    contact: row.contact,
                    all_subjects: row.all_subjects, // Boolean, if true the user is notified with all subjects
                    subjects_uid: row.subjects_uid, // M2M, the user will only be notified by selected subjects
                    active: row.active,
                    active_day: this.availabilityChecklist.includes('active_day'),
                    active_night: this.availabilityChecklist.includes('active_night'),
                    active_weekend: this.availabilityChecklist.includes('active_weekend'),
                    uid: row.uid,
                    url: row.url,
                };

                this.$store.dispatch('patchItem', {
                    item: item,
                    model: 'adminNotifConfigs',
                }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: `The admin configuration ${res.name} has been modified.`
                    });
                    this.editLineUid = '';
                    this.$refs.nsPaginate.loadContent();
                }).catch((e) => {
                    console.error(e);
                    this.$message({
                        type: 'error',
                        message: `There has been an error during the modification. Please retry or contact an administrator.`
                    });
                });
            } else {
                this.validSubjects = subjectsValid;
                this.validContact = contactValid;
            }

        },


        checkContactValid(value) {
            let regexPhone = /^(\+33|\+33)[6-7][0-9]{8}$/;
            let matchPhone = value.match(regexPhone);
            let regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let matchEmail = value.match(regexEmail);
            return value !== '' && (matchEmail !== null || matchPhone !== null);
        },

        checkSubjects(all_subjects, subjects_uid) {
            return all_subjects || (!all_subjects && subjects_uid.length !== 0);
        },
        errorText(uid) {
            if(this.contactIsInvalid(uid) && this.subjectsAreInvalid(uid)) {
                return 'Input a valid contact and choose at least one subject';
            }else if(this.contactIsInvalid(uid)) {
                return 'Contact should be a valid email or a phone number starting with +336 or +337';
            } else if (this.subjectsAreInvalid(uid)) {
                return 'Choose at least one subject';
            } else {
                return;
            }
        },

        onCreateConfig (){
            this.$refs.modal.open();
        },

        onAdminNotifCreated (){
            this.$refs.nsPaginate.loadContent();
        },
    },
};
</script>

<style lang="scss">

.is-error {
    input {
        border-color: #F56C6C;
    }
}

.subject-tag.el-tag{
    background-color: #444 !important;
    border-color: #444 !important;
    color: #bbb !important;
    .el-tag__close.el-icon-close {
        background-color: #bbb !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/ManageAlarmAlertNotification/index.vue